import { Document, Block, Text } from 'slate';
import { findDOMNode } from 'slate-react'

import {
  NODE_TYPE as NT,
  receivableTypes,
} from 'shared/constants/slate';

import { getMarks } from './utils';


// const isWhitespaceSensitiveNode = (node) => (
//   // TODO: Heading now has a inner paragraph wrapper
//   // so probably not necessary.
//   node.type === NT.paragraph
//   || node.type === NT.heading
// );


/*
 * Ensure no whitespace at the start of paragraph.
 */
const whitespaceAtStartRegex = /^\s+/;
const MakeRuleNoWhitespaceAtStart = (opts) => {
  const { matcher = node => false } = opts;

  return {
    match: node => matcher(node),

    validate: node => node.text.match(whitespaceAtStartRegex),

    normalize: (change, node, match) => {
      const firstText = node.getFirstText();
      const [ whitespace ] = match;
      return change.removeTextByKey(firstText.key, 0, whitespace.length);
    }
  };
};


/*
 * Ensure no more than one whitespace at the end of each paragraph.
 */
const multipleWhitespace = /\s{2,}/;
const MakeRuleNoMultipleWhitespaces = (opts) => {
  const { matcher = node => false } = opts;

  return {
    match: node => matcher(node),

    validate: node => node.text.match(multipleWhitespace),

    normalize: (change, node, match) => {
      const firstText = node.getTextAtOffset(match.index);
      const nextText = node.getTextAtOffset(match.index + 1);
      const [ whitespace ] = match;

      // Make sure selection is collapsed,
      // otherwise weird things may happen..!!!
      change.collapseToStart();

      if (firstText.key === nextText.key) {
        // Offset where match starts IN firstText (not node like match.index)
        const matchStartOffset = firstText.text.indexOf(whitespace);
        const targetOffset = matchStartOffset + whitespace.length;

        // Favor deleting forward for better behavior,
        // unless doesn't make sense to do it.
        const char = firstText.characters.get(targetOffset);
        return (char && /\s/.test(char.text)
          ? change.removeTextByKey(firstText.key, targetOffset, 1)
          : change.removeTextByKey(firstText.key, targetOffset-1, 1)
        );

      } else {
        return change.removeTextByKey(nextText.key, 0, 1);
      }
    },
  };
};



/*
 * CodeLine
 */
const MakeRuleUnsetOrphanCodeLine = (opts) => {
  return {
    // Match all blocks that are not code blocks
    match: node => {
      return (node.kind === 'block' || node.kind === 'document')
          && node.type !== opts.containerType;
    },

    validate: node => {
      const codeLines = node.nodes.filter(n => n.type === opts.lineType);

      if (codeLines.isEmpty()) {
        // All good
        return null;
      } else {
        // Wrap the orphan lines
        return {
          toReset: codeLines,
        };
      }
    },

    normalize: (change, node, value) => {
      return value.toReset.reduce((c, n) => {
        return c.setNodeByKey(n.key, opts.exitBlockType);
      }, change);
    },
  };
};

// Below strip* rules do NOT need to be used with
// EditCode plugin, it's a prep rule for transforming
// from codeBlock type to another.
const stripWhitespacesAtStartOfCodeLine = {
  match: node => node.type === NT.codeLine,

  validate: n => n.text.match(whitespaceAtStartRegex),

  normalize: (change, node, match) => {
    const firstText = node.getFirstText();
    const whitespaceLength = match[0].length;

    return change.removeTextByKey(firstText.key, 0, whitespaceLength);
  },
};

const stripExtraWhitespacesInCodeLine = {
  match: node => node.type === NT.codeLine,

  validate: n => n.text.match(multipleWhitespace),

  normalize: (change, node, match) => {
    // There should be only one text in codeLine..
    const firstText = node.getFirstText();
    const [ whitespace ] = match;
    const matchStartOffset = firstText.text.indexOf(whitespace);
    const targetLength = whitespace.length - 1;

    return change.removeTextByKey(firstText.key, matchStartOffset, targetLength);
  },
};

const whitespaceAtEndRegex = /\s+$/;
const stripWhitespacesAtEndOfCodeLine = {
  match: node => node.type === NT.codeLine,

  validate: n => n.text.match(whitespaceAtEndRegex),

  normalize: (change, node, match) => {
    const lastText = node.getLastText();
    const whitespaceLength = match[0].length;
    // Figure out offset from the end of text.
    const matchStartOffset = lastText.text.length - whitespaceLength;

    return change.removeTextByKey(lastText.key, matchStartOffset, whitespaceLength);
  },
};


// Always ensure there is at least one empty paragraph
// at the end of document so that it's easier for novice
// users to navigate using arrow keys.
const ensureEmptyParagraphAtEndOfDoc = {
  match: node => node.kind === 'document',

  validate: doc => {
    const lastNode = doc.nodes.last();
    if (lastNode.type !== NT.paragraph) {
      return true;
    }

    return (lastNode.isEmpty ? null : true);
  },

  normalize: (change, doc) => {
    const paragraph = Block.create(NT.paragraph);
    return change.insertNodeByKey(doc.key, doc.nodes.size, paragraph);
  },
};


// const joinAdjacentInlineCodes = {
//   match: (node) => node.kind === 'block',
//
//   validate: block => {
//     const { inlineCode } = NT;
//     const invalids = block.nodes.map((child, idx) => {
//       if (child.type !== inlineCode) {
//         return null;
//       }
//
//       const next = block.nodes.get(idx + 1);
//       if (!next || next.characters.size > 0) {
//         return null;
//       }
//
//       const target = block.nodes.get(idx + 2);
//       if (!target || target.type !== inlineCode) {
//         return null;
//       }
//
//       // Detected two adjacent inlineCodes w/ blank text inbetween.
//       return [ child, next, target ];
//     }).filter(Boolean);
//
//     return invalids.size ? invalids : null;
//   },
//
//   normalize: (change, node, invalids) => {
//     const [ first, blank, second ] = invalids.first();
//
//     const { isExpanded, isBackward } = change.state;
//     if (isExpanded) {
//       // Most likely from using shortcut to wrap
//       // preceding or following text into inlineCode.
//
//       if (isBackward) {
//         // Because.. this is easier.
//         change.flip();
//       }
//
//       const [ inline ] = change.state.inlines;
//       const { inlineCode } = NT;
//
//       // Select both, unwrap, rewrap..
//       change
//         .collapseToStartOf(first)
//         .extendToEndOf(second)
//         .unwrapInline(inlineCode)
//         .wrapInline(inlineCode);
//
//       // Figure out how the selection should end up.
//       switch (inline.key) {
//         case first.key:
//           return (change
//             .collapseToAnchor()
//             .extend(first.text.length)
//           );
//         case second.key:
//           return change.moveOffsetsTo(first.text.length, 0);
//         default:
//           return change;
//       }
//
//     } else {
//       // Most likely from deleting the part
//       // in between two inlineCodes.
//
//       // Fold second inlineCode into first, then remove
//       // both blank text in the middle and second inlineCode.
//       const targetOffset = first.text.length;
//       const targetText = first.getTextAtOffset(targetOffset);
//
//       return (change
//         .insertTextByKey(targetText.key, targetOffset, second.text)
//         .removeNodeByKey(blank.key)
//         .removeNodeByKey(second.key)
//         .move(-second.text.length)
//       );
//     }
//
//   },
// };


const invalidBlockTypesInBlockquote = [
  NT.heading,
  NT.blockquote,
  NT.codeBlock,
];
const resolveInvalidBlocksInBlockquote = {
  match: node => node.type === NT.blockquote,

  validate: target => {
    const invalids = target.filterDescendants(node => (
      invalidBlockTypesInBlockquote.includes(node.type)
    ));

    return (invalids.size === 0
      ? null
      : invalids
    );
  },

  normalize: (change, heading, invalids) => {
    const [ invalid ] = invalids;

    switch (invalid.type) {
      case NT.heading:
      case NT.blockquote:
        return change.unwrapBlockByKey(invalid.key);

      case NT.codeBlock:
        // Prepare a new text node with the entire text collapsed.
        const text = Text.create(invalid.text);

        // Remove all child nodes inside, set the block as
        // paragraph and add the new single text node.
        invalid.nodes.forEach(n => change.removeNodeByKey(n.key));
        return (change
          .setNodeByKey(invalid.key, NT.paragraph)
          .insertNodeByKey(invalid.key, 0, text)
        );

      default:
        // Brute force approach,
        // just remove the damn thing lol.
        return change.removeNodeByKey(invalid.key);
    }
  },
};


// NOTE: For now, invalid blocks in blockquote and how we want
// to resolve them is the same for list blocks. So just
// use the same rule but for match clause to keep things simple.
const resolveInvalidBlocksInList = {
  ...resolveInvalidBlocksInBlockquote,

  match: node => (
    node.type === NT.ul || node.type === NT.ol
  ),
};


/*
 * A rule that ensure targetNodeType has only one child
 * that is of paragraph type.
 * If not, replace all children with one paragraph with
 * text preserved in it.
 *
 * opts.matchFunc
 */
const MakeRuleMustContainOneParagraph = (opts) => ({
  match: node => {
    const { matchFunc } = opts;
    if (typeof matchFunc === 'function') {
      return matchFunc(node);
    }

    return false;
  },

  validate: target => {
    const nodes = target.nodes;
    if (nodes.size === 1
        && nodes.first().type === NT.paragraph) {
      return null;
    }

    return true;
  },

  normalize: (change, target) => {
    const line = target.text;
    const paragraph = Block.fromJSON({
      type: NT.paragraph,
      nodes: [ Text.create(line) ],
    });

    target.nodes.forEach(node => change.removeNodeByKey(node.key));
    return change.insertNodeByKey(target.key, 0, paragraph);
  },
});


/*
 * A rule that ensure targetNodeType has no marks in it.
 *
 * opts.matcher
 * opts.exceptFor: Array of exempted mark types.
 */
const MakeRuleMustNotHaveMarks = (opts) => {
  const { matcher = node => false } = opts;

  return {
    match: node => matcher(node),

    validate: node => {
      const { exceptFor = [] } = opts;
      const marks = getMarks(node).filter(mark => (
        exceptFor.includes(mark.type) === false
      ));

      return (marks.isEmpty()
        ? null
        : { removeMarks: marks }
      );
    },

    normalize: (change, node, { removeMarks }) => {
      const selection = change.value.selection;
      const range = selection.moveToRangeOf(node);

      return removeMarks.reduce(
        (c, mark) => c.removeMarkAtRange(range, mark),
        change
      );
    },
  };
};


const trappingBlockTypes = [
  NT.embed,
  NT.image,
  NT.codeBlock,
  NT.blockquote,
];
const ensureEndingParagraphToNavigate = {
  match: node => Document.isDocument(node),
  validate: doc => {
    if (doc.nodes.size === 1) {
      return null;  // headline
    }

    const lastBlock = doc.nodes.last();
    if (trappingBlockTypes.includes(lastBlock.type)) {
      return lastBlock;
    }
  },
  normalize: (change, doc) => {
    const index = doc.nodes.size;
    const paragraph = Block.create(NT.paragraph);
    return change.insertNodeByKey(doc.key, index, paragraph);
  },
};


const ensureNoTrailingEmptyBlocks = {
  match: node => Document.isDocument(node),
  validate: doc => {
    if (doc.nodes.size === 1) {
      return null;  // headline
    }

    const lastBlock = doc.nodes.last();

    return (lastBlock.isEmpty && !lastBlock.isVoid
      ? lastBlock
      : null
    )
  },
  normalize: (change, doc, block) => {
    return change.removeNodeByKey(block.key)
  },
};



// When moving away from receiver, it should not
// leave it behind but turn it into a paragraph. This
// happens when navigating within doc, but in some cases
// (e.g. undo) the node does not re-render so we should
// take care to normalize it. Used in HandleReceiver too.
// TODO: Right now we have to resort to findDOMNode to check
// this but latest/future slate should pass in value as well,
// so update it when ready?
const ensureNoOrphanReceiver = {
  match: node => (
    receivableTypes.includes(node.type)
    && node.data.get('isReceiving')
  ),
  validate: node => {
    const sel = window.getSelection();
    if (!sel) return;

    const { anchorNode } = sel;
    if (!anchorNode) return;

    const receiver = findDOMNode(node);
    if (!receiver) return;

    const isActive = receiver.contains(anchorNode);
    if (isActive) return;

    return node;
  },
  normalize: (change, node) => {
    return change
      .setNodeByKey(node.key, NT.paragraph)
  },
}


/*
 * A rule that ensure targetNodeType has no inlines.
 *
 * opts.targetNodeType
 */
const MakeRuleMustNotHaveInlines = (opts) => ({
  match: node => node.type === opts.targetNodeType,

  validate: node => {
    const inlines = node.getInlines();
    return (inlines.size === 0
      ? null
      : { toUnwrapInlines: inlines }
    );
  },

  normalize: (change, node, { toUnwrapInlines }) => {
    toUnwrapInlines.forEach(inline => change.unwrapInlineByKey(inline.key));
    return change;
  },
});


/*
 * A rule that ensure blockquotes always contain blocks.
 *
 * opts.targetNodeType
 * opts.wrapperBlockType
 */
const MakeRuleMustContainBlocks = (opts) => ({
  match: node => node.type === opts.targetNodeType,

  validate: item => {
    // Wrap text/inline nodes in default block
    const toWrap = item.nodes.filter(node => node.kind !== 'block');
    return toWrap.isEmpty() ? null : { toWrap };
  },

  normalize: (change, node, value) => {
    const {
      wrapperBlockType = NT.paragraph,
    } = opts;

    let wrapper = Block.create({ type: wrapperBlockType });
    // Remove extra empty text
    wrapper = wrapper.set('nodes', wrapper.nodes.slice(0, 0));

    change.insertNodeByKey(
      node.key,
      0,
      wrapper,
      // Be careful of Slate's core schema removing inlines or blocks when
      // a block contains a mix of them.
      { normalize: false }
    );

    value.toWrap.forEach((child, index) => {
      const isLast = index === value.toWrap.length - 1;
      change.moveNodeByKey(child.key, wrapper.key, index, { normalize: isLast });
    });

    return change;
  },
});



export {
  MakeRuleNoWhitespaceAtStart,
  MakeRuleNoMultipleWhitespaces,
  MakeRuleMustNotHaveMarks,

  ensureEndingParagraphToNavigate,
  ensureNoTrailingEmptyBlocks,
  ensureNoOrphanReceiver,

  // Below is from old slate version time..
  // TODO: clean any unused ones later.
  MakeRuleMustNotHaveInlines,
  MakeRuleUnsetOrphanCodeLine,
  MakeRuleMustContainBlocks,
  MakeRuleMustContainOneParagraph,

  stripWhitespacesAtStartOfCodeLine,
  stripExtraWhitespacesInCodeLine,
  stripWhitespacesAtEndOfCodeLine,
  ensureEmptyParagraphAtEndOfDoc,
  // joinAdjacentInlineCodes,
  resolveInvalidBlocksInBlockquote,
  resolveInvalidBlocksInList,
};



// WEBPACK FOOTER //
// ./src/components/slate/rules.js